<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="auto">
          <h6 class="m-0">Dados do Obra</h6>
        </d-col>
        <d-col>
          <span class="btn btn-success btn-sm ml-4" @click.prevent="toggleMode()">{{ searchProject ? 'Adicionar nova obra' : 'Buscar obra' }}</span>
        </d-col>
      </d-row>
    </d-card-header>

    <d-card-body class="d-flex flex-column">
      <no-permission v-if="isCustomer" />

      <template v-else>
        <d-form v-if="searchProject" @submit="save" class="d-flex flex-fill flex-column">
          <d-form-row>
            <!-- Nome -->
            <d-col md="8" class="form-group">
              <label for="name">Obra</label>
              <d-select
                class="form-control"
                v-model="model.project_id"
                @change="chooseProject"
              >
                <option v-for="option in projects" :key="option.id" :value="option.id" >{{ option.label }}</option>
              </d-select>
              <d-form-invalid-feedback>Obra é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
          <div v-if="model.project_id" class="border-top pb-4"></div>
        </d-form>
      </template>
      <project-form v-show="model.project_id || !searchProject" ref="projectForm" :customer-id="model.customer_id"/>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button class="btn btn-success" @click="save">Salvar e avançar</button>
          <button v-if="model.service.service_type === 'Fornecimento'" class="btn btn-success ml-4" @click="nextStep">Avançar</button>
        </d-col>
      </d-form-row>

    </d-card-body>

  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import ProjectForm from '_modules/project/components/ProjectForm.vue';
import { MODEL, _LOAD_MODEL_ } from '_modules/quotation/components/QuotationModel';
import {
  _SAVE_PROJECT_SUCCESS_,
  _LOAD_MODEL_ as _LOAD_MODEL_PROJECT_,
  MODEL as MODEL_PROJECT,
} from '_modules/project/components/ProjectModel';
import QuotationService from '_services/rest/modules/quotation';
import CustomerService from '_services/rest/modules/customer';
import NoPermission from './NoPermission.vue';


export default {
  name: 'Step-project',
  mixins: [MixinValidateForm],
  components: {
    Autocomplete,
    ProjectForm,
    NoPermission,
  },
  data() {
    return {
      searchProject: true,
      model: cloneDeep(MODEL),
      loading: false,
      projects: null,
    };
  },
  computed: {
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'getProjectList',
    ]),
    getProjects() {
      if (this.model.customer_id) {
        CustomerService.getProjectByCutomerId(this.model.customer_id)
          .then(response => {
            this.projects = response;
            this.$nextTick(() => {
              if (this.projects.length === 0) {
                this.searchProject = false;
              }
            });
          })
          .catch(error => {
            this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
          });
      }
    },
    chooseProject(projectId) {
      const [project] = this.projects.filter(item => item.id === projectId);
      this.setStateProject(project);
    },
    setStateProject(project) {
      this.model.project = { ...MODEL_PROJECT, ...project };
      this.$store.commit('setProject', this.model.project);
      Events.$emit(_LOAD_MODEL_PROJECT_, this.$store.state.project.project);
    },
    setQuotationProject(project) {
      this.model.project_id = project.id;
      this.model.project = project;
      this.setStateProject(project);
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    toggleMode() {
      this.searchProject = !this.searchProject;
      if (this.searchProject) {
        return this.chooseProject(this.model.project_id);
      }
      return this.setStateProject({});
    },
    save() {
      return this.$refs.projectForm.submit();
    },
    nextStep() {
        this.$router.push({ name: 'admin-quotation-deal', params: { quotationId: this.model.id } });
    },
    saveProject() {
      const { quotation } = this.$store.state.quotation;
      if (quotation && this.model.project_id === quotation.project_id) {
        this.$router.push({ name: 'admin-quotation-deal', params: { quotationId: this.model.id } });
      }
      this.model.step = 'project';
      QuotationService.updateQuotation(this.model)
        .then(response => {
          this.$store.commit('setQuotation', response);
          Events.$emit(_LOAD_MODEL_, response);
          this.$router.push({ name: 'admin-quotation-deal', params: { quotationId: response.id } });
        });
    },
    loadModel() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) {
        this.model = quotation;
      }
      this.setStateProject(this.model.project);
    },
  },
  destroyed() {
    Events.$off(_SAVE_PROJECT_SUCCESS_);
    Events.$off(_LOAD_MODEL_);
  },
  mounted() {
    this.loadModel();
    this.getProjects();
    Events.$on(_LOAD_MODEL_, quotation => {
      this.model = quotation;
      this.getProjects();
      this.loadModel();
    });
    Events.$on(_SAVE_PROJECT_SUCCESS_, projectSaved => {
      this.getProjects();
      this.setQuotationProject(projectSaved);
      this.saveProject();
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
